if (!customElements.get('hero-slideshow')) {
  class HeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSlider();
      
      if (Shopify.designMode) {
        this.handleSectionLoadBound = this.handleSectionLoad.bind(this);
        document.addEventListener('shopify:section:load', this.handleSectionLoadBound);
      }
    }

    disconnectedCallback() {
      if (this.swiper) this.swiper.destroy();
      
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.handleSectionLoadBound);
      }
    }

    handleSectionLoad(event) {
      if (event.detail.sectionId !== this.dataset.sectionId) return;
      if (this.swiper) this.swiper.destroy();
      this.initSlider();
    }

    initSlider() {
      if (typeof Swiper === 'undefined') {
        setTimeout(this.initSlider.bind(this), 50);
        return;
      }

      const container = this.querySelector('.swiper');
      if (!container) return;

      const autoplayEnabled = this.dataset.autoplay === 'true';
      const autoplayDelay = parseInt(this.dataset.speed, 10) * 1000 || 5000;
      
      const swiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'slide',
        loop: true,
        grabCursor: true,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
      };

      if (autoplayEnabled) {
        swiperOptions.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
        };
      }

      this.swiper = new Swiper(container, swiperOptions);
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);
}
